import React, { useEffect, useRef } from 'react';

// DESIGN V2 — the end of a long list loads the next page by itself when it
// scrolls into view (a "Load more" button is friction when browsing an
// artist's catalogue; it stays as the fallback for keyboards and for a
// browser without IntersectionObserver). Renders nothing when there is no more.
export default function AutoLoad({ onMore, loading = false, hasMore = true, label = 'Load more' }) {
    const ref = useRef(null);
    const onMoreRef = useRef(onMore); onMoreRef.current = onMore;
    const busyRef = useRef(false);
    useEffect(() => {
        const el = ref.current;
        if (!el || !hasMore || typeof IntersectionObserver === 'undefined') return undefined;
        const io = new IntersectionObserver((entries) => {
            if (!entries.some(e => e.isIntersecting) || busyRef.current || loading) return;
            busyRef.current = true;
            Promise.resolve(onMoreRef.current?.()).finally(() => { busyRef.current = false; });
        }, { rootMargin: '400px 0px' });
        io.observe(el);
        return () => io.disconnect();
    }, [hasMore, loading]);
    if (!hasMore && !loading) return null;
    return (
        <div className="v2-autoload" ref={ref} aria-live="polite">
            {loading
                ? <span className="mix-play-spinner" aria-label="Loading more" />
                : <button type="button" className="v2-btn sm quiet v2-load-more" onClick={() => onMoreRef.current?.()}>{label}</button>}
        </div>
    );
}

// Sort chips for a v2 list: "Sort: Popularity · Recent activity · A–Z".
export function SortChips({ value, onChange, modes, labels }) {
    return (
        <div className="v2-sort" role="group" aria-label="Sort">
            <span className="v2-sort-label">Sort:</span>
            {modes.map((m, i) => (
                <React.Fragment key={m}>
                    {i > 0 && <span className="v2-sort-sep">·</span>}
                    <button type="button" className={`v2-sort-link${value === m ? ' is-active' : ''}`} onClick={() => onChange(m)}>{labels[m] || m}</button>
                </React.Fragment>
            ))}
        </div>
    );
}
